import React, { useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
  useLoadScript,
} from "@react-google-maps/api";
import { getLabel, GOOGLE_KEY, useForceUpdate } from ".";
import { Button, Modal } from "react-bootstrap";

export const ViewMapsMarkerCustomer = ({
  points,
  setPoints,
  show,
  setShow,
}) => {
  const forceUpdate = useForceUpdate();
  const center = {
    lat: parseFloat(points?.[0]?.lat),
    lng: parseFloat(points?.[0]?.lng),
  };

  const libraries = ["places"];
  const mapContainerStyle = { width: "100%", height: "600px" };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_KEY,
    libraries,
  });

  const [selected, setSelected] = useState(null);

  const handleClose = () => {
    setShow(false);
    setSelected(null);
    forceUpdate();
  };

  const formattedPoints = points.map((point) => ({
    ...point,
    lat: parseFloat(point.lat),
    lng: parseFloat(point.lng),
  }));

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      dialogClassName="modal-70"
    >
      <Modal.Header closeButton>
        <Modal.Title>Maps</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoaded ? (
          <GoogleMap
            id="autocomplete-demo"
            mapContainerStyle={mapContainerStyle}
            zoom={12}
            center={center}
          >
            {formattedPoints.map((position, index) => (
              <Marker
                key={position.id}
                position={{ lat: position.lat, lng: position.lng }}
                label={{
                  text: position.label,
                  color: "black",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
                onClick={() => setSelected(position)}
              />
            ))}
            {selected && (
              <InfoWindow
                position={{ lat: selected.lat, lng: selected.lng }}
                onCloseClick={() => setSelected(null)}
              >
                <div>
                  <h3>{selected.store}</h3>
                  <p>{selected.address}</p>
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
        ) : (
          <div>Loading...</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleClose()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
